function getConfig(name, defaultValue = null) {
    // If inside a docker container, use window.ENV
    if (window.ENV !== undefined) {
        return window.ENV[name] || defaultValue;
    }

    return process.env[name] || defaultValue;
}

export function getBackendUrl() {
    return getConfig('REACT_APP_BACKEND_URL');
}

export function buildPublicUrl(path) {
    if (!path) return null;
    const backendUrl = getBackendUrl();
    if (!backendUrl || typeof backendUrl !== "string") return null;
    if (typeof path !== "string") return null;

    const trimmedPath = path.trim();
    const normalizedPath = trimmedPath.toLowerCase();
    if (
        !trimmedPath ||
        trimmedPath.startsWith("<") ||
        normalizedPath.includes("<!doctype") ||
        normalizedPath.includes("<html")
    ) {
        return null;
    }

    const encodedPath = trimmedPath
        .split("/")
        .map((segment) => encodeURIComponent(segment))
        .join("/");
    return `${backendUrl.replace(/\/+$/, "")}/public/${encodedPath}`;
}

export function getHoursCloseTicketsAuto() {
    return getConfig('REACT_APP_HOURS_CLOSE_TICKETS_AUTO');
}

export function getFrontendPort() {
    return getConfig('SERVER_PORT');
}

export function getPrimaryColor() {
    return getConfig("REACT_APP_PRIMARY_COLOR");
}

export function getPrimaryDark() {
    return getConfig("REACT_APP_PRIMARY_DARK");
}

export function getNumberSupport() {
    return getConfig("REACT_APP_NUMBER_SUPPORT");
}
